import { useFormik } from "formik";
import React, { useEffect, useState } from "react";

// Internal Components
import { IAtributoDetalle, IAttribute, TypeAttribute } from "../../interfaces/IAttribute";
import { COLORS } from "../../common/constants/colors";
import Paint from "../../common/components/Paint/Paint";
import EditTextForm from "../../common/components/EditTextForm/EditTextForm";
import GroupRow from "../../common/components/GroupRow/GroupRow";
import ModalContainer from "../../common/components/ModalContainer/ModalContainer";
import MarginInput from "../../common/components/MarginInput/MarginInput";
import SelectBox from "../../common/components/SelectBox/SelectBox";
import IColumn from "../../interfaces/IColumn";
import DetailTable from "../../common/components/DetailTable/DetailTable";
import ButtonGrid from "../../common/components/ButtonGrid/ButtonGrid";
import { DeleteOutlined, FormOutlined, RollbackOutlined } from "@ant-design/icons";
import OutLineButton from "../../common/components/OutLineButton/OutLineButton";
import { getError, makeTextPlain, openNotification, tryCatch } from "../../common/constants/Utilities";
import LoadingButton from "../../common/components/LoadingButton/LoadingButton";
import { InsertAttribute, UpdateAttribute } from "../../services/attribute";
import { IDepartment } from "../../interfaces/IDepartment";
import ModalBtnCotainer from "../../common/components/ModalBtnContainer/ModalBtnContainer";
import { Mode } from "../../common/types/AllTypes";
import globalStyle from "../../common/styles/globalStyle.module.css";
import './Atributos.css';
interface Props {
    attribute?: IAttribute;
    mode: Mode;
    setAttributeUpdate: any;
    setAddUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
    listDepartment: IDepartment[];
    loadingDeparment: boolean;
    setDataList: (list: IAttribute[]) => void;
    dataList: IAttribute[]
    defaultDepartmentGUID?: string;
}

const AddUpdateAttribute = ({ dataList, setDataList, attribute, mode, setAttributeUpdate, setAddUpdateModal, listDepartment, loadingDeparment, defaultDepartmentGUID }: Props) => {

    // States
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const [attrValue, setAttrValue] = useState<string>('');
    const [detailPosition, setDetailPosition] = useState<number | null>(null);
    const [detailUpdate, setDetailUpdate] = useState<IAtributoDetalle>();
    const [listDetalle, setListDetalle] = useState<IAtributoDetalle[]>([]);
    // Const
    const columns: IColumn[] = [
        {
            title: 'Detalle',
            dataIndex: 'atributoValor',
        },

        {
            title: '',
            dataIndex: '',
            render: (detail: IAtributoDetalle) => (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonGrid color={COLORS.black_text_color4} active={(formLoading || (detail.atributoValor !== detailUpdate?.atributoValor && !!detailUpdate)) ? false : true} icon={detailUpdate?.atributoValor === detail.atributoValor ? <RollbackOutlined /> : <FormOutlined />} method={() => selectDetail(detail)} />
                    <nav>&nbsp;&nbsp;</nav>
                    <ButtonGrid color={COLORS.black_text_color4} active={(formLoading || !!detailUpdate) ? false : true} icon={<DeleteOutlined />} method={() => removeDetail(detail.atributoValor)} />
                </div>
            )
        }
    ];

    // Handles
    const handleAttribute = (values: any) => {
        setFormLoading(true);
        const newAttribute: IAttribute = {
            atributoID: 0,
            departamentoID: parseInt(values.departamentoID),
            departamentoNombre: null,
            nombre: values.nombre,
            descripcion: values.descripcion,
            atributoTipo: parseInt(values.atributoTipo),
            atributoDetalle: listDetalle,
        }

        tryCatch(() => {
            if (mode === 'Add') {
                InsertAttribute(newAttribute)
                    .then((response) => {
                        openNotification('success', `Atributo agregado`, response.msg!);
                        setAddUpdateModal(false);

                        // reset Table
                        let result: IAttribute = response.data;
                        result.departamentoNombre = listDepartment.find(det => det.departamentoID === result.departamentoID)!.nombre;
                        dataList.push(result);
                        setDataList([...dataList]);
                        //
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setFormLoading(false));
            } else {
                newAttribute.atributoID = attribute!.atributoID;
                UpdateAttribute(newAttribute)
                    .then((response) => {
                        openNotification('success', `Atributo Modificado`, response.msg!);
                        setAddUpdateModal(false);
                        setAttributeUpdate(response.data);

                        // reset Table
                        let result: IAttribute = response.data;
                        result.departamentoNombre = listDepartment.find(det => det.departamentoID === result.departamentoID)!.nombre;
                        let attr = dataList.findIndex(x => x.atributoID === attribute?.atributoID);
                        dataList[attr] = result;
                        setDataList([...dataList]);
                        //
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setFormLoading(false));
            }
        })



    }

    // Methods
    const validations = (values: any) => {
        const errors: any = {};
        if (!values.nombre) {
            errors.nombre = 'Requerido';
        }

        if (!values.departamentoID) {
            errors.departamentoID = 'Requerido';
        }

        if (!values.atributoTipo) {
            errors.atributoTipo = 'Requerido';
        }

        return errors;
    };

    const addDetail = () => {
        if (!!attrValue) {
            if (listDetalle.some(atr => makeTextPlain(atr.atributoValor) === makeTextPlain(attrValue))) {
                openNotification('error', 'Ya existe', `El detalle ${attrValue} ya existe`);
            } else {
                let exit = attribute?.atributoDetalle.find(atr => atr.atributoValor.toLowerCase() === attrValue.toLowerCase());
                const newAttr: IAtributoDetalle = {
                    atributoDetalleID: mode === 'Update' && !!exit ? exit.atributoDetalleID : 0,
                    atributoID: mode === 'Update' ? attribute!.atributoID : 0,
                    atributoValor: attrValue.trim()
                }
                setListDetalle(!!listDetalle ? [...listDetalle, newAttr] : [newAttr]);
                setAttrValue('');
            }
        }
    }

    const selectDetail = (atr: IAtributoDetalle) => {
        if (!detailUpdate) {
            setDetailUpdate(atr);
            setAttrValue(atr.atributoValor);
            setDetailPosition(listDetalle.findIndex(item => item.atributoValor === atr.atributoValor))
        } else {
            setDetailUpdate(undefined);
            setAttrValue('');
            setDetailPosition(null);
        }
    }

    const updateDetail = () => {
        if (!!attrValue) {
            const found = listDetalle.findIndex(atr => makeTextPlain(atr.atributoValor) === makeTextPlain(attrValue));


            if (found !== -1 && found !== detailPosition) {
                openNotification('error', 'Ya existe', `El detalle ${attrValue} ya existe`);
            } else {
                let listInternal = listDetalle;
                // let exist = listInternal.findIndex(att => att.atributoValor === detailUpdate?.atributoValor);
                detailUpdate!.atributoValor = attrValue;
                listInternal[detailPosition!] = detailUpdate!;
                setListDetalle(listInternal);
                // // Finally
                setDetailUpdate(undefined);
                setAttrValue('');
            }
        }
    }

    const removeDetail = (detail: string) => {
        const list = listDetalle.filter(attr => attr.atributoValor !== detail);
        setListDetalle(list);
    }

    // Form
    const AttributeForm = useFormik({
        initialValues: { nombre: '', descripcion: '', departamentoID: '', atributoTipo: '' },
        validate: validations,
        onSubmit: (values: any) => handleAttribute(values)
    });

    // Effects
    useEffect(() => {
        if (mode === 'Update') {
            AttributeForm.setValues({
                nombre: attribute!.nombre,
                descripcion: attribute!.descripcion,
                departamentoID: attribute!.departamentoID.toString(),
                atributoTipo: attribute!.atributoTipo.toString()
            });
            setListDetalle(attribute!.atributoDetalle);
        }

    }, [attribute]);

    useEffect(() => {
        if (!!defaultDepartmentGUID) {
            const departId = listDepartment.find(dep => dep.departamentoGUID === defaultDepartmentGUID)?.departamentoID;
            AttributeForm.setFieldValue('departamentoID', departId);
        }
    }, [])


    return (
        <ModalContainer>
            <GroupRow>
                <MarginInput width="45%">
                    <label>Nombre:</label>
                    <EditTextForm
                        value={AttributeForm.values.nombre}
                        onChange={AttributeForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"nombre"}
                        placeholder={"Nombre"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!formLoading}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{AttributeForm.errors.nombre && AttributeForm.errors.nombre}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Departamento:</label>
                    <SelectBox
                        value={AttributeForm.values.departamentoID}
                        defaultValue={mode === 'Update' ? attribute!.departamentoID : null}
                        placeholder={"Departamento"}
                        disabled={mode === 'Update' || !!defaultDepartmentGUID ? true : false}
                        allowClear={false}
                        loading={loadingDeparment}
                        onChange={(value: string) => AttributeForm.setFieldValue('departamentoID', value)}
                        options={listDepartment.map(dep => ({ key: dep.departamentoGUID, value: dep.departamentoID.toString(), text: dep.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{AttributeForm.errors.departamentoID && AttributeForm.errors.departamentoID}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>


            <GroupRow>
                <MarginInput width="45%">
                    <label>Descripcion:</label>
                    <EditTextForm
                        value={AttributeForm.values.descripcion}
                        onChange={AttributeForm.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"descripcion"}
                        placeholder={"Descripcion"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!formLoading}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Tipo:</label>
                    <SelectBox
                        value={AttributeForm.values.atributoTipo}
                        defaultValue={mode === 'Update' ? attribute!.atributoTipo : null}
                        placeholder={"Tipo de atributo"}
                        allowClear={false}
                        disabled={false}
                        onChange={(value: string) => { AttributeForm.setFieldValue('atributoTipo', value); if (value === TypeAttribute.Texto.toString()) { setListDetalle([]) } }}
                        options={[{ key: '1T', value: '1', text: 'Detalle' }, { key: '2T', value: '2', text: 'Texto' }]}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{AttributeForm.errors.atributoTipo && AttributeForm.errors.atributoTipo}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            {AttributeForm.values.atributoTipo === TypeAttribute.Detalle.toString() &&
                <div className="detail_container">
                    <MarginInput width="100%">
                        <label>Valor:</label>
                        <div style={{ marginBottom: '10px', width: "100%", display: 'grid', gridTemplateColumns: '2.5fr 1fr', columnGap: '5px' }}>
                            <EditTextForm
                                value={attrValue}
                                inForm={false}
                                onChange={(value: string) => setAttrValue(value)}
                                backgroundcolor={COLORS.white_color2(1)}
                                name={"valor"}
                                placeholder={"Valor"}
                                borderColor={COLORS.black_text_color3}
                                textColor={COLORS.black_text_color1}
                                active={!formLoading}
                                type={'text'}
                            />
                            <OutLineButton color={!!detailUpdate ? COLORS.white_color1 : COLORS.blue_active} backgroundColor={!!detailUpdate ? COLORS.blue_main(1) : COLORS.transparent_color1} text={!!detailUpdate ? "Modificar Detalle" : "Añadir Detalle"} method={!!detailUpdate ? updateDetail : addDetail} />
                        </div>
                    </MarginInput>
                    <DetailTable
                        props={{ rowKey: (record: any) => record.atributoValor }}
                        dataSource={listDetalle}
                        columns={columns}
                        loading={false}
                        paginationActive={!detailUpdate}
                    />
                </div>
            }

            <ModalBtnCotainer>
                <LoadingButton
                    type="button"
                    disabled={!!detailUpdate}
                    method={AttributeForm.handleSubmit}
                    title={mode === 'Add' ? "Guardar" : 'Modificar'}
                    loading={formLoading.toString()}
                    background={COLORS.blue_active}
                    color={COLORS.white_color1}
                    style={{ padding: '3px', width: '200px', margin: 'auto', height: '32px' }}
                    fontsize={16}
                />
            </ModalBtnCotainer>

        </ModalContainer>

    );
}


export default AddUpdateAttribute;